import { useEffect, useState } from 'react';
import type { PendingCode } from '../lib/api.ts';

/**
 * A pending enrolment code, with a live countdown.
 *
 * The code is grouped in fours and set in a monospace face because
 * somebody is reading it aloud over the phone while a technician types
 * it. Ambiguity here costs a site visit.
 */
export const CodeCard = ({ code }: { readonly code: PendingCode }) => {
  const [left, setLeft] = useState(Math.floor(Number(code.seconds_left)));

  useEffect(() => {
    const id = setInterval(() => setLeft((n) => Math.max(n - 1, 0)), 1000);
    return () => clearInterval(id);
  }, []);

  const mins = Math.floor(left / 60);
  const secs = left % 60;
  const grouped = `${code.code.slice(0, 4)} ${code.code.slice(4)}`;

  return (
    <div className={left === 0 ? 'codeCard dead' : 'codeCard'}>
      <div>
        <span className="codeVal">{grouped}</span>
        {code.device_name && (
          <span className="codeFor">for {code.device_name}</span>
        )}
      </div>
      <span className="mono">
        {left === 0
          ? 'expired'
          : `${mins}:${String(secs).padStart(2, '0')} left`}
      </span>
    </div>
  );
};
